import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import { Link } from "react-router-dom";
import { normalizeAmount, formatData } from "../../utils/transformer.util";
import {
  Button,
  Select,
  Textarea,
  SearchSelect,
} from "../../components/base/index";
import { JADWAL_MATPEL_LIST_TABLE_FIELDS } from "../../constants/Student/student.constant";

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class DataJadwalMatpel extends Component {
  constructor(props) {
    super(props);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickCetak = this._onClickCetak.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._renderButtons = this._renderButtons.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._onClickDetails = this._onClickDetails.bind(this);
    this._onClickBack = this._onClickBack.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._getSemesterOptions = this._getSemesterOptions.bind(this);
    this._onClickPosting = this._onClickPosting.bind(this);
    this._ttlJP = this._ttlJP.bind(this);
    this._getNotesUnpostingSch = this._getNotesUnpostingSch.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._onClickSet = this._onClickSet.bind(this);
    this._onClickSync = this._onClickSync.bind(this);
    this._checkSync = this._checkSync.bind(this);
    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;

    this.state = {
      page: 1,
      isTable: true,
      selected: {},
      content: initialContent,
      canSync: false,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          levels_id,
          classrooms: [],
          levels: [],
          classrooms_id: "",
          listjadwal: [],
          listDetails: [],
          user_id: user.id,
        },
        error: {
          classrooms: "",
          levels: "",
        },
      },
      param: {},
      filtered: false,
    };
  }

  componentDidMount() {
    const { user, location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { organizations_id, user_group } = user;
    const { content, form, filters } = this.state;
    // console.log(data)
    //   if (isEdit && data) {
    //   this._onSearchContentDetails(data);
    // }
    let savedForm =
      JSON.parse(window.localStorage.getItem("JadwalMapelForm")) || "";
    let savedFilters =
      JSON.parse(window.localStorage.getItem("JadwalMapelFilters")) || filters;
    if (savedForm != "" && user.id != savedForm.value.user_id) {
      savedForm = "";
      savedFilters = filters;
    }
    this._initializeData(savedFilters);
    if (savedForm != "") {
      this.setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            units_id: savedFilters.units_id ? savedFilters.units_id : "",
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
          // entrance_year : savedFilters.entrance_year,
        },
      }));
      if (user_group.name === "pusat" || user_group.name === "pengurus") {
        console.log(savedFilters);
        console.log(savedForm);
        this._getPeriodsOptions({
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
        });
      }
    }
    // this._getPrmLevels({ filters: {units_id: [school_unit.id], organizations_id: organizations_id } });
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { content } = this.state;
    const { school_unit, user_group } = user;

    if (user_group.name !== "pusat" || user_group.name !== "pengurus") {
      await this._getPeriodsOptions({ units_id: school_unit.id });
      // this._onSearchContent();
      this._getNotesUnpostingSch();
      this._ttlJP();
    }
    await this._getSchoolUnitsOptions();

    if (user_group.name == "pusat" || user_group.name === "pengurus") {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            period: savedFilters.period,
          },
        }),
        () => {
          // commonActions.setLoading({ show: true });
          this._onSearchContent();
        },
      );
    } else {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
          },
        }),
        () => {
          // commonActions.setLoading({ show: true });
          this._onSearchContent();
        },
      );
    }
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find((item) => item.value == units_id);

    // console.log(units_id)
    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _checkSync(periods_id) {
    const { handleCheckSyncSemester, user } = this.props;
    const { school_unit, user_group } = user;

    let units_id = "";

    if (user_group.name === "pusat" || user_group.name === "pengurus") {
      units_id = this.state.filters.units_id
        ? this.state.filters.units_id.value
        : "";
    } else {
      units_id = school_unit.id;
    }

    console.log("CHECK SYNC PARAM:", {
      periods_id,
      units_id,
    });

    if (!periods_id || !units_id) {
      this.setState({
        canSync: false,
      });
      return;
    }

    try {
      const res = await handleCheckSyncSemester({
        periods_id,
        units_id,
      });

      console.log("CHECK SYNC RESULT:", res);

      // sementara untuk testing
      this.setState({
        canSync: res && res.can_sync === true,
      });
    } catch (err) {
      console.log("CHECK SYNC ERROR:", err);

      this.setState({
        canSync: false,
      });
    }
  }

  async _getNotesUnpostingSch(payload = {}) {
    const { filters, param, form } = this.state;
    const { getNotesUnpostingSch, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units =
      user_group.name == "pusat" ||
      user_group.name == "perwakilan" ||
      user_group.name === "pengurus"
        ? filters.units_id
          ? filters.units_id
          : ""
        : school_unit.id;
    console.log(units);

    const res = await getNotesUnpostingSch({
      ...payload,
      organizations_id,
      units_id: units,
      period_id: filters.period,
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState((prevState) => ({
      ...prevState,
      notes: res,
    }));
  }

  async _ttlJP(payload = {}) {
    const { filters, param, form } = this.state;
    const { handleGetJp, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units =
      user_group.name == "pusat" ||
      user_group.name == "perwakilan" ||
      user_group.name === "pengurus"
        ? filters.units_id
          ? filters.units_id
          : ""
        : school_unit.id;
    console.log(units);

    const res = await handleGetJp({
      ...payload,
      levels_id: levels_id,
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState((prevState) => ({
      ...prevState,
      ttl_jp: res,
    }));
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  _onClickAdd() {
    const { history } = this.props;
    const { ttl_jp } = this.state;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      isEdit: true,
      ttl_jp: ttl_jp,
    });
  }

  onClickEdit(val) {
    const { history } = this.props;
    const { ttl_jp } = this.state;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      data: val,
      ttl_jp: ttl_jp,
      isEdit: true,
    });
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }
  async _getSemesterOptions(filters = {}) {
    const { getSemesterOptions } = this.props;

    const res = await getSemesterOptions(filters);

    const now = new Date();

    const currentSemester = res.find((item) => {
      const startDate = new Date(item.start_date);
      const endDate = new Date(item.end_date);

      return now >= startDate && now <= endDate;
    });

    this.setState(
      (prevState) => ({
        ...prevState,

        param: {
          ...prevState.param,
          semesters: res,
        },

        filters: {
          ...prevState.filters,
          semester_id: currentSemester ? currentSemester.value : "",
        },

        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            semester_id: currentSemester ? currentSemester.value : "",
          },
        },
      }),
      () => {
        console.log("PANGGIL CHECK SYNC");

        this._checkSync(filters.periods_id);
      },
    );
  }

  _onClickCetak() {
    const { history } = this.props;
    history.push(
      "/dashboard/kurikulum/mata-pelajaran/cetak/jadwal-mata-pelajaran",
    );
  }

  // async _getPeriodsOptions(filters = {}) {
  //   const { getPeriodsOptions } = this.props;
  //   const res = await getPeriodsOptions(filters);

  //   map(res, (data, idx) => {
  //     const date = new Date();
  //     const start_date = new Date(data.attributes.start_date);
  //     if (date > start_date) {
  //       // tahun ajaran sekarang
  //       this.setState((prevState) => ({
  //         ...prevState,
  //         form: {
  //           ...prevState.form,
  //           value: {
  //             ...prevState.form.value,
  //             periods_id: data.value,
  //           },
  //         },
  //         filters: {
  //           ...prevState.filters,
  //           period: data.value,
  //         },
  //       }));

  //       // INI TRIGGER-NYA
  //       this._getSemesterOptions({
  //         periods_id: data.value
  //       });
  //     }
  //   });

  //   this.setState((prevState) => ({
  //     ...prevState,
  //     param: {
  //       ...prevState.param,
  //       periods: res,
  //     },
  //   }));
  // }
  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions } = this.props;

    const res = await getPeriodsOptions(filters);

    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    // Tentukan tahun ajaran berjalan
    const currentAcademicYear =
      month >= 7 ? `${year}-${year + 1}` : `${year - 1}-${year}`;

    // Cari period yang sedang berjalan
    const currentPeriod = res.find(
      (item) => item.label === currentAcademicYear,
    );

    if (currentPeriod) {
      const periods_id = currentPeriod.value;

      // SET PERIOD
      this.setState((prevState) => ({
        ...prevState,

        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            periods_id,
          },
        },

        filters: {
          ...prevState.filters,
          period: periods_id,
        },

        param: {
          ...prevState.param,
          periods: res,
        },
      }));

      // CUMA SEKALI
      await this._getSemesterOptions({
        periods_id,
      });
    } else {
      this.setState((prevState) => ({
        ...prevState,

        param: {
          ...prevState.param,
          periods: res,
          semesters: [],
        },
      }));
    }
  }
  async _onClickDetails(val, idx) {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/data-jadwal-matpel-details", {
      data: val,
      // isEdit: true,
    });
  }

  _onClickBack() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      page: prevState.page - 1,
    }));
  }

  _onFormChange(event) {
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName];
          newListError = prevState.form.error[fieldName];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            levels_id: value,
            organizations_id,
          });
        }
      },
    );
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;

    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { students_id = "", period, units_id, semester_id } = filters;
    const { periods_id } = form.value;

    console.log(semester_id);
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const { handleListScheduleSubject, user } = this.props;
          const { organizations_id, school_unit, user_group } = user;
          const { units_id } = school_unit;
          console.log(period);
          const result = await handleListScheduleSubject({
            ...params,
            organizations_id,
            units_id:
              user_group.name == "pusat" || user_group.name === "pengurus"
                ? filters.units_id.value
                : school_unit.id,
            periods_id: period,
            semester_id: semester_id,
            filters,
          });
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listjadwal: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listjadwal: [],
              },
            },
          }));
        }
        // }
      },
    );
  }

  async _onSearchContentDetails(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { period } = filters;
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { user_group } = user;
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const { handlelistReportSchedule, user } = this.props;
          const { organizations_id, school_unit } = user;
          const { units_id } = school_unit;

          const result = await handlelistReportSchedule({
            ...params,
            organizations_id,
            units_id:
              user_group.name == "pusat" || user_group.name === "pengurus"
                ? filters.units_id.value
                : school_unit.id,
            // classrooms_id: classrooms_id,
            periods_id: period,

            filters,
          });
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: [],
              },
            },
          }));
        }
        // }
      },
    );
  }

  async onClickDelete(id) {
    const { handleDeleteScheduleSubject } = this.props;
    const res = await handleDeleteScheduleSubject(id);
    if (res) {
      this._onSearchContent();
    }
  }

  _renderButtons(data) {
    const { user } = this.props;
    const { user_group } = user;
    const button = {};

    console.log(data.is_posting);

    return (
      <td>
        <div className="table__actions">
          {user_group.name == "pusat" || user_group.name === "pengurus" ? (
            <Button
              onClick={() => this._onClickDetails(data)}
              title="Lihat Detail"
            />
          ) : (
            <>
              {data.is_posting == 0 || data.is_posting === null ? (
                <Button onClick={() => this.onClickEdit(data)} title="Edit" />
              ) : (
                ""
              )}
              <Button
                onClick={() => this._onClickDetails(data)}
                title="Lihat Detail"
              />
            </>
          )}
        </div>
      </td>
    );
  }

  onSubmit(e) {
    e.preventDefault();
    // const { form} = this.state;
    const { form } = this.state;
    const { handleAddBudget, history, user } = this.props;
    const { workingUnit, prm_school_units_id } = user;

    let unit_id = prm_school_units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    handleAddBudget(form.value, history.goBack, unit_id);
    // handleAddBudget(form.value, plafon, history.goBack, unit_id);
    // handleAddBudget(form.value, history.goBack, unit_id);
  }

  async _onClickPosting() {
    const { filters, form } = this.state;
    const { value } = form;
    const { period } = filters;
    const { handleGenerateSchedule, history, user } = this.props;
    const { school_unit, user_group, organizations_id } = user;
    const res = await handleGenerateSchedule({
      organizations_id: organizations_id,
      units_id: school_unit.id,
      periods_id: period,
    });
    if (res) {
      history.push("/dashboard/pengaturan/data-jadwal-matpel");

      // this._onSearchContent();
      history.go(0);
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
        window.localStorage.setItem(
          "JadwalMapelForm",
          JSON.stringify(this.state.form),
        );
        window.localStorage.setItem(
          "JadwalMapelFilters",
          JSON.stringify(this.state.filters),
        );

        if (name === "units_id") {
          const param = this.state.param.units;
          console.log(value.value);
          const levels_units = param.find((i) => i.value == value.value)
            ? param.find((i) => i.value == value.value).attributes.levels_id
            : "";

          console.log(levels_units);
          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                levels_id: levels_units,
                units_id: value,
              },
            },
          }));
          this._getPeriodsOptions({ units_id: value.value });
        }

        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            filters: { levels_id: value, organizations_id },
          });
        }
        if (name === "period") {
          this._getSemesterOptions({ periods_id: value.value });
        }
        this._onSearchContent();
        this._onSearchContentDetails();
      },
    );
  }

  _onClickSet() {
    this.setState(
      (prevState) => ({
        ...prevState,
        isTable: false,
        filters: {
          ...prevState.filters,
        },
      }),
      () => {
        this._onSearchContent();
      },
    );
  }

async _onClickSync() {
  const { filters } = this.state;
  const { user, handleSyncSemester } = this.props;
  const { school_unit, user_group } = user;

  const units_id =
    user_group.name === "pusat" || user_group.name === "pengurus"
      ? filters.units_id.value
      : school_unit.id;

  const periods_id = filters.period;

  try {
    const res = await handleSyncSemester({
      units_id,
      periods_id,
    });

    console.log("SYNC RESULT:", res);

    if (res && res.success) {
      // cek ulang apakah jadwal Genap sudah ada
      await this._checkSync(periods_id);

      // refresh data jadwal
      this._onSearchContent();
    }
  } catch (err) {
    console.log("SYNC ERROR:", err);
  }
}
  render() {
    const {
      form,
      param,
      filters,
      page,
      notes,
      isTable,
      canSync,
    } = this.state;
    const { value } = form;
    const { listjadwal, listDetails } = form.value;

    const { classrooms_id = "" } = filters;
    const { handleGetKelas, handleDeleteKelas, coa, classrooms, user } =
      this.props;
    const { user_group } = user;
    const componentRef = React.createRef();
    console.log(listjadwal[0] ? listjadwal[0].is_posting : "");

    const semesterGenap = param.semesters
  ? param.semesters.find((item) => item.label === "Genap")
  : null;

console.log("SEMESTER GENAP:", semesterGenap);
console.log("CAN SYNC:", canSync);

const today = new Date();

const todayDate = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate()
);

const parseLocalDate = (dateString) => {
  if (!dateString) return null;

  const [year, month, day] = dateString.split("-").map(Number);

  return new Date(year, month - 1, day);
};

const genapStartDate = semesterGenap
  ? parseLocalDate(semesterGenap.start_date)
  : null;

const showSyncButton =
  semesterGenap &&
  genapStartDate &&
  todayDate >= genapStartDate &&
  canSync;

console.log("TODAY:", todayDate);
console.log("GENAP START:", genapStartDate);
console.log(
  "DATE CONDITION:",
  genapStartDate ? todayDate >= genapStartDate : false
);
console.log("SHOW SYNC:", showSyncButton);
    console.log("SHOW SYNC:", showSyncButton);
    console.log("TODAY:", todayDate);
console.log("GENAP START:", genapStartDate);
console.log("DATE CONDITION:", todayDate >= genapStartDate);
    const formattedNotes = notes
      ? notes
          .map((item) => {
            const [date, time] = item.created_at.split(" ");
            return `${date}  ${item.notes}\n${time}`;
          })
          .join("\n\n")
      : "";
    return (
      <div className="add-budget">
        {user_group.name === "pusat" || user_group.name === "pengurus" ? (
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <SearchSelect
                noMargin
                async={false}
                name="units_id"
                list={param.units}
                inputArray
                onClick={this._onChangeFilter}
                placeholder="Pilih Unit"
                value={form.value.units_id}
                rightIcon="icon-search"
                label="Pilih Unit"
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="add-budget">
          <div className="nilai-kognitif__custom-form-row">
            <Select
              name="period"
              label="Tahun Ajaran"
              placeholder="Pilihan"
              onChange={this._onChangeFilter}
              data={param.periods}
              value={filters.period}
              disabled={user_group.name == "pusat" ? false : true}
            />
            <div className="data-pelanggaran__custom-form-row__field" />
            <Select
              name="semester_id"
              label="Semester"
              placeholder="Pilihan"
              onChange={this._onChangeFilter}
              data={param.semesters}
              value={filters.semester_id}
              disabled={user_group.name == "pusat" ? false : true}
            />
          </div>
        </div>

        {page == 1 && (
          <>
            {user_group.name == "pusat" || user_group.name === "pengurus" ? (
              <Button
                className="button_save"
                title="Proses"
                onClick={this._onClickSet}
              />
            ) : (
              <>
                <div
                  className="beginning-balance__button-wrapper"
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <Button
                    style={{ backgroundColor: "darkgreen" }}
                    title="Buat Jadwal"
                    onClick={this._onClickAdd}
                  />

                  {showSyncButton && (
                    <Button
                      style={{ backgroundColor: "orange" }}
                      title="Sinkronisasi"
                      onClick={this._onClickSync}
                    />
                  )}
                </div>

                {listjadwal &&
                listjadwal[0] &&
                (listjadwal[0].is_posting === 0 ||
                  listjadwal[0].is_posting === null) ? (
                  <div style={{ marginTop: "2%" }}>
                    <Button
                      style={{ backgroundColor: "darkgreen" }}
                      title="Posting"
                      onClick={this._onClickPosting}
                    />
                  </div>
                ) : (
                  ""
                )}

                {!isEmpty(notes) ? (
                  (
                    listjadwal
                      ? listjadwal[0]
                        ? listjadwal[0].is_posting == 0
                        : ""
                      : ""
                  ) ? (
                    <div>
                      <Textarea
                        name="notes"
                        label="Catatan"
                        placeholder="Pilihan"
                        onChange={this._onChangeFilter}
                        value={formattedNotes}
                        readOnly
                        style={{ height: "120px" }}
                        // disabled
                      />
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </>
            )}
            {(!isTable && user_group.name == "pusat") ||
            user_group.name === "pengurus" ? (
              <div className="student-list__button2">
                <div className="fund-request__content">
                  <table className="table" ref={componentRef}>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th style={{ width: "30%" }}>Kelas</th>
                        <th style={{ width: "10%" }}>Opsi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {map(listjadwal, (list, idx) => (
                        <tr key={`budget_row_${idx}`}>
                          {
                            <>
                              <td>{idx + 1}</td>
                              <td>{list.class_name}</td>
                            </>
                          }
                          {this._renderButtons(list)}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="student-list__button2">
                <div className="fund-request__content">
                  <table className="table" ref={componentRef}>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th style={{ width: "30%" }}>Kelas</th>
                        <th style={{ width: "10%" }}>Opsi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {map(listjadwal, (list, idx) => (
                        <tr key={`budget_row_${idx}`}>
                          {
                            <>
                              <td>{idx + 1}</td>
                              <td>{list.class_name}</td>
                            </>
                          }
                          {this._renderButtons(list)}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
        {page == 2 && (
          <>
            <div className="student-list__button2">
              <Button onClick={this._onClickBack} title="Kembali" />
            </div>
            <div className="student-list__button2">
              <div className="fund-request__content">
                <table
                  className="table"
                  ref={componentRef}
                  style={{ width: "150%" }}
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>Jam</th>
                      <th rowSpan={2} style={{ width: "10%" }}>
                        Pukul
                      </th>
                      <th colSpan={2}>Senin</th>
                      <th colSpan={2}>Selasa</th>
                      <th colSpan={2}>Rabu</th>
                      <th colSpan={2}>Kamis</th>
                      <th colSpan={2}>Jumat</th>
                      <th colSpan={2}>Sabtu</th>
                    </tr>
                    <tr>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {map(listDetails, (list, idx) => (
                      <tr key={`budget_row_${idx}`}>
                        <td>{idx+1}</td>
                        <td>{list.hour}</td>
                        {!isEmpty(list.sch) && (
                          map(list.sch, (item, idx) => (
                            <>
                            {(() => {
                              if(item.name == "Senin"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Selasa"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Rabu"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Kamis"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Jumat"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Sabtu"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                            })()}
                            </>
                            
                          ))
                      )}
                      </tr>
                    ))} */}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
DataJadwalMatpel.propTypes = {
  handleListClassData: PropTypes.func,
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
DataJadwalMatpel.defaultProps = {
  handleListClassData: noop,
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
